import { Fragment } from "react";
import type { ElementType } from "@/react/types/Element";
import { ButtonElement } from "./ElementTypes/ButtonElement";
import { FieldElement } from "./ElementTypes/FieldElement";
import { TextElement } from "./ElementTypes/TextElement";

interface RenderElementProps {
  element: ElementType;
  isPreview: boolean;
  isSubmitting: boolean;
  initialFocusRef?: React.RefObject<HTMLInputElement>;
  fieldIndex: number;
  errors: Record<number, string>;
}
const renderElement = ({
  element,
  isPreview,
  isSubmitting,
  initialFocusRef,
  fieldIndex,
  errors,
}: RenderElementProps) => {
  switch (element.type) {
    case "text":
      return <TextElement element={element} />;
    case "field":
      return (
        <FieldElement
          element={element}
          initialFocusRef={initialFocusRef}
          fieldIndex={fieldIndex}
          errors={errors}
        />
      );
    case "button":
      return (
        <ButtonElement
          element={element}
          isPreview={isPreview}
          isSubmitting={isSubmitting}
        />
      );
  }
};

interface ElementsRendererProps {
  formElements: ElementType[];
  isPreview: boolean;
  initialFocusRef?: React.RefObject<HTMLInputElement>;
  isSubmitting: boolean;
  errors: Record<number, string>;
}

export const ElementsRenderer = ({
  formElements,
  isPreview,
  initialFocusRef,
  isSubmitting,
  errors,
}: ElementsRendererProps) => {
  const firstInputIndex = formElements.findIndex(
    element => element.type === "field",
  );
  let fieldCount = 0;

  return (
    <>
      {formElements.map((element, index) => {
        const fieldIndex = element.type === "field" ? fieldCount++ : -1;
        return (
          <Fragment key={element.id}>
            {renderElement({
              element,
              isPreview,
              isSubmitting,
              errors,
              initialFocusRef:
                index === firstInputIndex ? initialFocusRef : undefined,
              fieldIndex,
            })}
          </Fragment>
        );
      })}
    </>
  );
};
